export default function PageHeader({ eyebrow, title, description, action }) {
  return (
    <div className="flex items-end justify-between gap-6 mb-8 pb-6 border-b border-slate-200/60">
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.22em] text-purple-700 mb-2">{eyebrow}</div>
        )}
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
        {description && (
          <p className="text-sm text-slate-600 mt-2 max-w-2xl">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
